import luckysheetConfigsetting from "./luckysheetConfigsetting";
import { zoomChange } from "./zoom";
import sheetmanage from "./sheetmanage";
import server from "./server";
import { rowLocationByIndex, colLocationByIndex, mouseposition, rowLocation, colLocation } from "../global/location";
import Store from "../store";
import { luckysheet_searcharray } from "./sheetSearch";
import menuButton from "../controllers/menuButton";
import { luckysheetDrawMain } from "../global/draw";
import { luckysheetdefaultstyle, modelHTML } from "./constant";
import { selectionCopyShow } from "./select";
import dataVerificationCtrl from "./dataVerificationCtrl";
import formula from "../global/formula";
import { getRangeAxis, getScreenshot, getTxtByRange } from "../global/api";
import { getObjType, replaceHtml } from "../utils/util";
import { hasPartMC } from "../global/validate";
import tooltip from "../global/tooltip";
import { getSheetIndex } from "../methods/get";
import imageCtrl from "./imageCtrl";
import { hideAllNeedRangeShow } from "../expendPlugins/chart/plugin";
import { parseDataToNumber } from "../utils/chartUtil";
import { calculatePrintRange } from "../utils/printCellDetector";

let ExcelPlaceholder = {
	"[tabName]": "&A",
	"[CurrentDate]": "&D",
	"[fileName]": "&F",
	"[background]": "&G",
	"[Shadow]": "&H",
	"[TotalPages]": "&N",
	"[pageNumber]": "&P",
	"[CurrentTime]": "&T",
	"[filePath]": "&Z",
};

// 需要记录当前打印的相关参数
let printParam = {
	// 当前打印的页码Array
	pageArray: [],
	// 当前打印选区
	printSelection: null,
};

// 获取1mm的像素
function getOneMmsPx() {
	let div = document.createElement("div");
	div.style.width = "1mm";
	document.querySelector("body").appendChild(div);
	let mm1 = div.getBoundingClientRect();
	let w = mm1.width;
	$(div).remove();
	return w;
}

/**
 * @description 获取纸张大小
 * @param {*} type
 * @returns
 */
function getPaperSize(type) {
	// 默认A4纸张大小 210x297mm 转换为像素 - 这个值是A4纸张的像素大小，固定不变的，需要将其绑定到单元格上，跟随单元格缩放
	const paperWidth = 210 * getOneMmsPx() * Store.zoomRatio;
	// const paperWidth = 210 * Store.zoomRatio;
	const paperHeight = 297 * getOneMmsPx() * Store.zoomRatio;
	// const paperHeight = 297 * Store.zoomRatio;
	return { paperWidth, paperHeight };
}

function viewChange(curType, preType) {
	let currentSheet = sheetmanage.getSheetByIndex();

	if (currentSheet.config == null) {
		currentSheet.config = {};
	}

	if (currentSheet.config.sheetViewZoom == null) {
		currentSheet.config.sheetViewZoom = {};
	}

	let defaultZoom = 1,
		type = "zoomScaleNormal";
	if (curType == "viewNormal") {
		type = "viewNormalZoomScale";
	} else if (curType == "viewLayout") {
		type = "viewLayoutZoomScale";
	} else if (curType == "viewPage") {
		type = "viewPageZoomScale";
		defaultZoom = 0.6;
	}

	let curZoom = currentSheet.config.sheetViewZoom[type];
	if (curZoom == null) {
		curZoom = defaultZoom;
	}

	currentSheet.config.curentsheetView = curType;

	if (Store.clearjfundo) {
		Store.jfredo.push({
			type: "viewChange",
			curType: curType,
			preType: preType,
			sheetIndex: Store.currentSheetIndex,
		});
	}

	// Store.zoomRatio = curZoom;
	// server.saveParam("all", Store.currentSheetIndex, curZoom, { "k": "zoomRatio" });
	server.saveParam("cg", Store.currentSheetIndex, curType, { k: "curentsheetView" });

	Store.currentSheetView = curType;

	zoomChange(curZoom);
}

/**
 * @description 对传入的起始结束行列进行页码分割，返回分割后的行列数据
 * 	1. 目前设计的思路是 A4 尺寸页码大小需要附和到上一个单元格上，保证一个单元格被完整打印
 *  2. 如果不包含结束行列，则需要手动添加
 * @param { number } startRow
 * @param { number } endRow
 * @param { number } startColumn
 * @param { number } endColumn
 * @returns
 */
function getPageSplitArray(startRow, endRow, startColumn, endColumn) {
	let rows = [];
	let columns = [];

	const { paperWidth, paperHeight } = getPaperSize();

	// 这里是循环当前行一共可分为多少页
	for (let r = startRow; r < endRow; r++) {
		// 如果行被隐藏了 则跳过
		if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) continue;

		// 当前行的 Y 坐标 - 真实的 y 坐标，与可视区无关
		let current_end_y = Store.visibledatarow[r];

		// 前一行的 Y 坐标 - 真实的 y 坐标，与可视区无关
		let prev_end_y = r > 0 ? Store.visibledatarow[r - 1] : 0;

		// 计算相对于前一个分页线的坐标
		let relativeCurrentY = current_end_y;
		let relativePrevY = prev_end_y;

		// 如果已经有分页线，则基于上一个分页线计算相对位置
		if (rows.length > 0) {
			let lastPageBreak = rows[rows.length - 1].rowIndex;
			let lastPageBreakY = Store.visibledatarow[lastPageBreak];
			relativeCurrentY = current_end_y - lastPageBreakY;
			relativePrevY = prev_end_y - lastPageBreakY;
		}

		// 计算当前行属于第几个页面（基于页面高度的倍数）
		let currentPageIndex = Math.floor(relativeCurrentY / paperHeight);

		// 计算前一行属于第几个页面
		let prevPageIndex = Math.floor(relativePrevY / paperHeight);

		// 如果当前行和前一行属于不同的页面，说明当前行是新页面的开始行
		if (currentPageIndex > prevPageIndex) {
			rows.push({
				rowIndex: r,
				y: current_end_y,
				h: current_end_y - (rows[rows.length - 1] ? rows[rows.length - 1].y : 0),
			});
		}
	}

	// 循环所有列
	for (let c = startColumn; c < endColumn; c++) {
		// 如果列被隐藏了 则跳过
		if (Store.config && Store.config["colhidden"] != null && Store.config["colhidden"][c] != null) continue;

		// 当前列的 X 坐标 - 真实的 x 坐标，与可视区无关
		let current_end_x = Store.visibledatacolumn[c];

		// 前一列的 X 坐标 - 真实的 x 坐标，与可视区无关
		let prev_end_x = c > 0 ? Store.visibledatacolumn[c - 1] : 0;

		// 计算相对于前一个分页线的坐标
		let relativeCurrentX = current_end_x;
		let relativePrevX = prev_end_x;

		// 如果已经有分页线，则基于上一个分页线计算相对位置
		if (columns.length > 0) {
			let lastPageBreak = columns[columns.length - 1].colIndex;
			let lastPageBreakX = Store.visibledatacolumn[lastPageBreak];
			relativeCurrentX = current_end_x - lastPageBreakX;
			relativePrevX = prev_end_x - lastPageBreakX;
		}

		// 计算当前列属于第几个页面（基于页面宽度的倍数）
		let currentPageIndex = Math.floor(relativeCurrentX / paperWidth);

		// 计算前一列属于第几个页面
		let prevPageIndex = Math.floor(relativePrevX / paperWidth);

		// 如果当前列和前一列属于不同的页面，说明当前列是新页面的开始列
		if (currentPageIndex > prevPageIndex) {
			columns.push({
				colIndex: c,
				x: current_end_x,
				w: current_end_x - (columns[columns.length - 1] ? columns[columns.length - 1].x : 0),
			});
		}
	}

	// 处理结束行列
	if (!rows.find((r) => r.rowIndex === endRow)) {
		const current_end_y = Store.visibledatarow[endRow - 1];
		rows.push({
			rowIndex: endRow,
			y: current_end_y,
			h: current_end_y - (rows[rows.length - 1] ? rows[rows.length - 1].y : 0),
		});
	}

	if (!columns.find((c) => c.colIndex === endColumn)) {
		const current_end_x = Store.visibledatacolumn[endColumn - 1];
		columns.push({
			colIndex: endColumn,
			x: current_end_x,
			w: current_end_x - (columns[columns.length - 1] ? columns[columns.length - 1].x : 0),
		});
	}

	return { rows, columns };
}

/**
 * @description 在分页预览模式下绘制页面边界线和页码
 */
function printLineAndNumberCreate() {
	if (Store.flowdata == null) {
		return;
	}

	let scrollWidth = $("#luckysheet-cell-main").scrollLeft();
	let scrollHeight = $("#luckysheet-cell-main").scrollTop();
	let drawWidth = Store.luckysheetTableContentHW[0];
	let drawHeight = Store.luckysheetTableContentHW[1];
	let offsetLeft = Store.rowHeaderWidth;
	let offsetTop = Store.columnHeaderHeight;

	// 获取canvas上下文
	const luckysheetTableContent = $("#luckysheetTableContent").get(0).getContext("2d");
	luckysheetTableContent.save();
	// 保持与 drawMain 一致的缩放
	luckysheetTableContent.scale(Store.devicePixelRatio, Store.devicePixelRatio);

	const { fill_col_ed, fill_row_ed } = getStartAndEndRowAndCol(scrollWidth, scrollHeight, drawWidth, drawHeight);

	// 计算表格的宽高 - 可视区的宽高哈，并不是真实的完整的表格宽高
	const sheetWidth = fill_col_ed - scrollWidth;
	const sheetHeight = fill_row_ed - scrollHeight;

	// 必须知道全部的页码，才能正确地绘制出 第几页 的关系。
	const rowCount = Store.visibledatarow.length;
	const colCount = Store.visibledatacolumn.length;

	const { rows, columns } = getPageSplitArray(0, rowCount, 0, colCount);

	// 一行可以被分为多少页？
	const rowPageCount = columns.length;

	// 则每新增一行，都以 rowPageCount 为倍数递增即可
	for (let i = 0; i < rows.length; i++) {
		// 这个是行的 Y 值哈
		const row = rows[i];

		// 为了实现居中，当前间隔的中心坐标是
		const currentY = row.y;
		const prevY = i > 0 ? rows[i - 1].y : 0;
		const centerY = currentY - (currentY - prevY) / 2 - scrollHeight;

		// 绘制水平线
		drawPrintLine(
			luckysheetTableContent,
			offsetLeft,
			row.y - scrollHeight + offsetTop,
			sheetWidth + offsetLeft,
			row.y - scrollHeight + offsetTop
		);

		for (let j = 0; j < columns.length; j++) {
			// 实现 X 居中，原理类似
			const col = columns[j];
			const currentX = col.x;
			const prevX = j > 0 ? columns[j - 1].x : 0;
			const centerX = currentX - (currentX - prevX) / 2 - scrollWidth + offsetLeft;

			// 绘制垂直线 - 类似
			drawPrintLine(
				luckysheetTableContent,
				col.x - scrollWidth + offsetLeft,
				offsetTop,
				col.x - scrollWidth + offsetLeft,
				sheetHeight + offsetTop
			);

			drawPageNumbers(luckysheetTableContent, centerX, centerY, i * rowPageCount + j + 1);
		}
	}

	// 恢复canvas状态
	luckysheetTableContent.restore();
}

/**
 * @description 辅助函数 - 绘制打印页码，实现水平垂直居中显示"第几页"
 * @param {CanvasRenderingContext2D} ctx - Canvas绘图上下文
 * @param {Number} x - 绘制的X坐标
 * @param {Number} y - 绘制的Y坐标
 * @param {Number} pageNum - 页码
 * @param {String} [font="18px Arial"] - 字体样式
 * @param {String} [fillStyle="#55bb8a"] - 填充颜色
 */
function drawPageNumbers(ctx, x, y, pageNum, font = "18px Arial", fillStyle = "#55bb8a") {
	ctx.save();
	ctx.font = font;
	ctx.fillStyle = fillStyle;

	const text = `第${pageNum}页`;
	// 获取文本宽度
	const textWidth = getTextWidth(ctx, text);
	// 获取文本高度
	const textHeight = getTextHeight(ctx, text);
	ctx.fillText(text, x - textWidth / 2, y + textHeight / 2);
	ctx.restore();
}

/**
 * @description 辅助函数 - 绘制打印线
 * @param {CanvasRenderingContext2D} ctx - Canvas绘图上下文
 * @param {Number} startX - 起始X坐标
 * @param {Number} startY - 起始Y坐标
 * @param {Number} endX - 结束X坐标
 * @param {Number} endY - 结束Y坐标
 * @param {Number} [lineWidth=1] - 线宽
 * @param {String} [strokeStyle="#55bb8a"] - 线颜色
 * @param {Array} [lineDash=[10, 6]] - 虚线样式
 * */
function drawPrintLine(ctx, startX, startY, endX, endY, lineWidth = 1, strokeStyle = "#55bb8a", lineDash = [10, 6]) {
	ctx.save();
	ctx.beginPath();
	ctx.strokeStyle = strokeStyle;
	ctx.lineWidth = lineWidth;
	ctx.setLineDash(lineDash);
	ctx.moveTo(startX, startY);
	ctx.lineTo(endX, endY);
	ctx.stroke();
	ctx.closePath();
	ctx.restore();
}

/**
 * @description 辅助函数 - 获取起始和结束行列坐标
 * @param {Number} scrollWidth - 水平滚动距离
 * @param {Number} scrollHeight - 垂直滚动距离
 * @param {Number} drawWidth - 绘制区域宽度
 * @param {Number} drawHeight - 绘制区域高度
 * @returns {Object} 包含行列坐标的对象
 */
function getStartAndEndRowAndCol(scrollWidth, scrollHeight, drawWidth, drawHeight) {
	let columnOffsetCell = 0;
	let rowOffsetCell = 0;

	// 表格渲染区域起止行列下标
	let dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed;

	dataset_row_st = luckysheet_searcharray(Store.visibledatarow, scrollHeight);
	dataset_row_ed = luckysheet_searcharray(Store.visibledatarow, scrollHeight + drawHeight);

	if (dataset_row_st == -1) {
		dataset_row_st = 0;
	}

	dataset_row_st += rowOffsetCell;

	if (dataset_row_ed == -1) {
		dataset_row_ed = Store.visibledatarow.length - 1;
	}

	dataset_row_ed += rowOffsetCell;

	if (dataset_row_ed >= Store.visibledatarow.length) {
		dataset_row_ed = Store.visibledatarow.length - 1;
	}

	dataset_col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth);
	dataset_col_ed = luckysheet_searcharray(Store.visibledatacolumn, scrollWidth + drawWidth);

	if (dataset_col_st == -1) {
		dataset_col_st = 0;
	}

	dataset_col_st += columnOffsetCell;

	if (dataset_col_ed == -1) {
		dataset_col_ed = Store.visibledatacolumn.length - 1;
	}

	dataset_col_ed += columnOffsetCell;

	if (dataset_col_ed >= Store.visibledatacolumn.length) {
		dataset_col_ed = Store.visibledatacolumn.length - 1;
	}

	// 表格渲染区域起止行列坐标
	let fill_row_st, fill_row_ed, fill_col_st, fill_col_ed;

	if (dataset_row_st == 0) {
		fill_row_st = 0;
	} else {
		fill_row_st = Store.visibledatarow[dataset_row_st - 1];
	}
	fill_row_ed = Store.visibledatarow[dataset_row_ed];

	if (dataset_col_st == 0) {
		fill_col_st = 0;
	} else {
		fill_col_st = Store.visibledatacolumn[dataset_col_st - 1];
	}
	fill_col_ed = Store.visibledatacolumn[dataset_col_ed];

	return { dataset_row_st, dataset_row_ed, dataset_col_st, dataset_col_ed, fill_col_ed, fill_row_ed };
}

/**
 * @description 通过 sheet 表进行打印 - 默认当前 sheet 页
 */
async function getScreenshotBySheet(sheetIndex, printGridLine) {
	// 就是遍历当前 sheet 有数据的行列，重新计算 A4 尺寸，重新分页实现

	// 非空单元格行列 起止坐标
	let nonEmptyRows = [];
	let nonEmptyCols = [];

	// 是异步的，需要暂存，最后统一处理
	let sheetScreenshot = [];

	let ch_width = 0;
	let rh_height = 0;
	let scrollWidth = 0;
	let scrollHeight = 0;

	// 使用优化的非空单元格检测函数
	const printRangeResult = calculatePrintRange({
		includeMergedCells: true,
		includeStyledCells: true,
		includeBorderedCells: true,
		includeConditionalFormatting: true,
		includeAlternateFormatting: true,
	});

	nonEmptyRows.push(...printRangeResult.nonEmptyRows);
	nonEmptyCols.push(...printRangeResult.nonEmptyCols);

	// 对非空单元格进行排序
	nonEmptyRows.sort((a, b) => a - b);
	nonEmptyCols.sort((a, b) => a - b);

	// 计算页码，进行打印
	const { rows, columns } = getPageSplitArray(
		nonEmptyRows[0],
		nonEmptyRows[nonEmptyRows.length - 1] + 1,
		nonEmptyCols[0],
		nonEmptyCols[nonEmptyCols.length - 1] + 1
	);

	// 这里得到的是当前 sheet 页有值的单元格进行分页后，单元格的行列范围，需要再循环实现页码打印
	// 则每新增一行，都以 rowPageCount 为倍数递增即可
	for (let i = 0; i < rows.length; i++) {
		for (let j = 0; j < columns.length; j++) {
			// 这里每一个数据项 都是一个页码，都需要进行打印
			ch_width = columns[j].w;
			rh_height = rows[i].h;
			scrollWidth = columns[j].x - ch_width;
			scrollHeight = rows[i].y - rh_height;
			const screenshot = await handleScreenshot(scrollWidth, scrollHeight, ch_width, rh_height, printGridLine);
			sheetScreenshot.push(screenshot);
		}
	}

	return sheetScreenshot;
}

/**
 * @description 截取指定页码的页面
 * @param { number } pageNum
 * @returns
 */
async function getScreenshotByPageNum(pageNum = 1, printGridLine = true) {
	if (!pageNum) return;

	// 请注意,每一个的宽高不一定相等,因为设计为跟随单元格了,而不是固定的 210mm,如果设定为 固定的话,所有的处理将非常简单
	let ch_width = 0;
	let rh_height = 0;
	let scrollWidth = 0;
	let scrollHeight = 0;

	// 当前的总行数
	const rowCount = Store.visibledatarow.length;
	const colCount = Store.visibledatacolumn.length;

	const { rows, columns } = getPageSplitArray(0, rowCount, 0, colCount);
	let findSuccess = false;

	//  一行可以被分为多少页？
	const rowPageCount = columns.length;
	// 则每新增一行，都以 rowPageCount 为倍数递增即可
	for (let i = 0; i < rows.length; i++) {
		if (findSuccess) break;

		for (let j = 0; j < columns.length; j++) {
			if (findSuccess) break;

			const currentPage = i * rowPageCount + j + 1;
			if (pageNum === currentPage) {
				// 计算宽高
				ch_width = columns[j].w;
				rh_height = rows[i].h;
				scrollWidth = columns[j].x - ch_width;
				scrollHeight = rows[i].y - rh_height;
				findSuccess = true;
			}
		}
	}

	// 没有找到该页码，请重试！

	if (!findSuccess) {
		console.warn(`没有找到 ${pageNum} 页码，请重试！`);
		tooltip.info(`没有找到 ${pageNum} 页码，请重试！`, "");
		return null;
	}
	// 进行后续的操纵
	return await handleScreenshot(scrollWidth, scrollHeight, ch_width, rh_height, printGridLine);
}

/**
 * @description 截取指定单元格页面
 * @param { range: string | {rows:{},columns:{}}} options
 * @returns
 */
async function getScreenshotBySelection(options = {}, printGridLine = true) {
	let { range = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1] } = { ...options };

	if (getObjType(range) == "string") {
		if (!formula.iscelldata(range)) {
			return tooltip.info("The range parameter is invalid.", "");
		}

		let cellrange = formula.getcellrange(range);
		range = {
			row: cellrange.row,
			column: cellrange.column,
		};
	}

	if (getObjType(range) != "object" || range.row == null || range.column == null) {
		return tooltip.info("The range parameter is invalid.", "");
	}

	let str = range.row[0],
		edr = range.row[1],
		stc = range.column[0],
		edc = range.column[1];

	let has_PartMC = hasPartMC(Store.config, str, edr, stc, edc);

	if (has_PartMC) {
		return tooltip.info("Cannot perform this operation on partially merged cells", "");
	}

	let visibledatarow = Store.visibledatarow;
	let visibledatacolumn = Store.visibledatacolumn;

	let scrollHeight, rh_height;
	if (str - 1 < 0) {
		scrollHeight = 0;
		rh_height = visibledatarow[edr];
	} else {
		scrollHeight = visibledatarow[str - 1];
		rh_height = visibledatarow[edr] - visibledatarow[str - 1];
	}

	let scrollWidth, ch_width;
	if (stc - 1 < 0) {
		scrollWidth = 0;
		ch_width = visibledatacolumn[edc];
	} else {
		scrollWidth = visibledatacolumn[stc - 1];
		ch_width = visibledatacolumn[edc] - visibledatacolumn[stc - 1];
	}

	// 进行后续的操纵
	return await handleScreenshot(scrollWidth, scrollHeight, ch_width, rh_height, printGridLine);
}

/**
 * @description 截图的后续处理工作
 * 	1. 进行 drawMain 绘制主内容区
 *  2. 补上边框和上边框
 *  3. 进行 统计图表 绘制 - 注意层级关系
 *  4. 进行图片绘制 - 注意层级关系
 * 	5. 进行水印优化
 */
async function handleScreenshot(scrollWidth, scrollHeight, ch_width, rh_height, printGridLine = true) {
	// 取用户传递的 打印像素比
	const devicePixelRatio = luckysheetConfigsetting.printDevicePixelRatio || Store.devicePixelRatio;

	let newCanvas = $("<canvas>")
		.attr({
			width: Math.ceil(ch_width * devicePixelRatio),
			height: Math.ceil(rh_height * devicePixelRatio),
		})
		.css({ width: ch_width, height: rh_height });

	luckysheetDrawMain(scrollWidth, scrollHeight, ch_width, rh_height, 1, 1, null, null, newCanvas, devicePixelRatio, 1, { printGridLine });
	let ctx_newCanvas = newCanvas.get(0).getContext("2d");

	// 补齐统计图
	await printChart(ctx_newCanvas, scrollWidth, scrollHeight, ch_width, rh_height);

	// 补齐图片
	await printImage(ctx_newCanvas, scrollWidth, scrollHeight, ch_width, rh_height);

	return newCanvas.get(0).toDataURL("image/png");
}

/**
 * @description 打印统计图
 * @param {CanvasRenderingContext2D} ctx
 */
async function printChart(ctx, scrollWidth, scrollHeight, ch_width, rh_height, devicePixelRatio) {
	// 隐藏图表选中，需要先取消，不然处理截图报错
	hideAllNeedRangeShow();

	// 获取当前表的图片列表，判断其是否在渲染区域内
	let charts = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)]?.chart || {};
	if (!charts || !charts.length) return;

	// 创建一个Promise数组来处理所有统计图的异步加载
	const chartPromises = [];

	charts.forEach((chart) => {
		const { chart_id } = chart;
		const left = parseDataToNumber(chart.left);
		const top = parseDataToNumber(chart.top);
		const width = parseDataToNumber(chart.width);
		const height = parseDataToNumber(chart.height);

		// 判断统计图是否处于打印范围
		if (!isInPrintRange({ left, top, width, height, scrollHeight, scrollWidth, rh_height, ch_width })) return;

		const chartPromise = new Promise((resolve, reject) => {
			// html-to-image 截图会有 style 异常BUG
			// html2canvas 截图不够清晰
			// 因此，直接获取原始 canvas 进行截图处理，但是需要自行处理 padding 属性、backgroundColor
			// padding 值是在 ctx fillRect 时 确定位置使用，图片还是通过 ctx.drawImage 绘制的
			const chart_box = $(`#${chart_id}_c`);
			if (!chart_box) return;
			// 不然先获取原始 canvas 的结果
			const originCanvas = $(chart_box).find("canvas").get(0);
			if (!originCanvas) resolve();
			const dataURL = originCanvas.toDataURL("image/png");

			// 创建图片
			const imageElement = new Image();
			imageElement.src = dataURL;
			imageElement.onload = () => {
				ctx.save();
				ctx.scale(devicePixelRatio, devicePixelRatio);
				// 这些值理论上不可修改，这里直接定义，如果后期需要修改，请动态获取
				const padding = [20, 10];
				const backgroundColor = "#fff";
				const borderRadius = 10;
				// 开始绘制统计图
				ctx.fillStyle = backgroundColor;
				// 绘制圆角矩形有BUG，用矩形代替
				ctx.fillRect(left, top, width, height);
				// 开始处理统计图数据
				ctx.drawImage(imageElement, left + padding[1], top + padding[0], width - 2 * padding[1], height - 2 * padding[0]);
				ctx.restore();
				resolve();
			};
			imageElement.onerror = resolve;
		});
		chartPromises.push(chartPromise);
	});

	await Promise.all(chartPromises);
}

/**
 * @description 打印图片
 *  ## 注意事项：
 * 		1. 要兼容固定位置的图片 isFixedPos 固定位置的图片 滚动后位置是固定的，因此可能别的页码打印需要渲染
 * 		2. 只有固定位置时， fixedLeft fixedTop 属性才有用，并且 position = fixed 时，其 left top 是相对于 body 实现的，需要重新计算
 * 		3. src 始终指向源文件，需要考虑裁剪 crop 属性
 * 		4. 还需要考虑 border 属性 边框不在源文件中
 * 		5. default 指向当前图片的属性： width height left top
 * @param {CanvasRenderingContext2D} ctx
 * @param {Number} scrollWidth
 * @param {Number} scrollHeight
 * @param {Number} drawWidth
 * @param {Number} drawHeight
 */
async function printImage(ctx, scrollWidth, scrollHeight, ch_width, rh_height, devicePixelRatio) {
	//图片 active/cropping，需要先取消，不然处理截图报错
	if ($("#luckysheet-modal-dialog-activeImage").is(":visible") || $("#luckysheet-modal-dialog-cropping").is(":visible")) {
		imageCtrl.cancelActiveImgItem();
	}

	// 获取当前表的图片列表，判断其是否在渲染区域内
	let imageList = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)]?.images || {};
	if (!imageList || !Object.keys(imageList).length) return Promise.resolve();

	// 创建一个Promise数组来处理所有图片的异步加载
	const imagePromises = [];

	let offsetLeft = Store.rowHeaderWidth;
	let offsetTop = Store.columnHeaderHeight;

	// ## 方案一 通过 ctx 主动绘制方案
	// 创建一个Promise数组来处理所有图片的异步加载;
	for (let key in imageList) {
		const image = imageList[key];
		let { border, crop, isFixedPos, fixedLeft, fixedTop, src } = image;

		// const { left, top, width, height } = image.default;
		const left = image.default.left * Store.zoomRatio;
		const top = image.default.top * Store.zoomRatio;
		const width = image.default.width * Store.zoomRatio;
		const height = image.default.height * Store.zoomRatio;

		// 如果图片固定位置
		if (isFixedPos) {
			// 判断固定位置是否在打印区域内
			// 1. 先重新计算position 相对于 canvas 的left top 属性
			// ## 当移动到最左上角时，其值是 46 147 相对于 body 的 left top 值，需要转换为 canvas 内的坐标
			// ## 属性是 position:fixed; left: 46px; top: 147px;

			const mainCanvas = $("#luckysheetTableContent").get(0);
			const { x, y } = mainCanvas.getBoundingClientRect();
			const imageLeft = (fixedLeft - x - offsetLeft) * Store.zoomRatio;
			const imageTop = (fixedTop - y - offsetTop) * Store.zoomRatio;
			if (isInPrintRange({ left: imageLeft, top: imageTop, width, height, scrollHeight, scrollWidth, rh_height, ch_width })) {
				const imagePromise = new Promise((resolve, reject) => {
					const imageElement = new Image();
					imageElement.src = src;
					imageElement.onload = () => {
						ctx.save();
						ctx.scale(devicePixelRatio, devicePixelRatio);

						// 1. 绘制图片
						// 宽高相等，偏移为0 则认为图片没有被裁剪，不然则被裁剪,裁剪后，直接通过 canvas 实现即可
						if (isCrop(crop, image.default)) {
							const sx = crop.offsetLeft * Store.zoomRatio;
							const sy = crop.offsetTop * Store.zoomRatio;
							const sw = crop.width * Store.zoomRatio;
							const sh = crop.height * Store.zoomRatio;
							const dx = imageLeft;
							const dy = imageTop;
							const dw = crop.width * Store.zoomRatio;
							const dh = crop.height * Store.zoomRatio;
							// 八个形参实现裁剪功能
							ctx.drawImage(imageElement, sx, sy, sw, sh, dx, dy, dw, dh);
						} else {
							const dx = imageLeft;
							const dy = imageTop;
							const dw = width; // 需要这两个参数实现缩放
							const dh = height; // 需要这两个参数实现缩放
							ctx.drawImage(imageElement, dx, dy, dw, dh);
						}

						// 2. 绘制边框
						if (border.width) {
							const x = imageLeft - scrollWidth;
							const y = imageTop - scrollHeight;
							const w = width;
							const h = height;
							drawImageBorder(x, y, w, h, border);
						}

						ctx.restore();
					};
					resolve();
				});
				imagePromises.push(imagePromise);
			}
		} else {
			// 图片处于打印区域，开始处理打印
			if (isInPrintRange({ left, top, width, height, scrollHeight, scrollWidth, rh_height, ch_width })) {
				// 图片处于打印区域，开始处理打印
				const imagePromise = new Promise((resolve) => {
					const imageElement = new Image();
					imageElement.src = src;
					imageElement.onload = () => {
						ctx.save();
						ctx.scale(devicePixelRatio, devicePixelRatio);

						// 1. 绘制图片
						// 宽高相等，偏移为0 则认为图片没有被裁剪，不然则被裁剪,裁剪后，直接通过 canvas 实现即可
						if (isCrop(crop, image.default)) {
							const sx = crop.offsetLeft * Store.zoomRatio;
							const sy = crop.offsetTop * Store.zoomRatio;
							const sw = crop.width * Store.zoomRatio;
							const sh = crop.height * Store.zoomRatio;
							const dx = left;
							const dy = top;
							const dw = crop.width * Store.zoomRatio;
							const dh = crop.height * Store.zoomRatio;
							// 八个形参实现裁剪功能
							ctx.drawImage(imageElement, sx, sy, sw, sh, dx, dy, dw, dh);
						} else {
							const dx = left;
							const dy = top;
							const dw = width; // 需要这两个参数实现缩放
							const dh = height; // 需要这两个参数实现缩放
							ctx.drawImage(imageElement, dx, dy, dw, dh);
						}
						// 2. 绘制边框
						if (border.width) {
							const x = (image.default.left - scrollWidth) * Store.zoomRatio;
							const y = (image.default.top - scrollHeight) * Store.zoomRatio;
							const w = width;
							const h = height;
							drawImageBorder(x, y, w, h, border);
						}

						ctx.restore();

						resolve();
					};
				});
				imagePromises.push(imagePromise);
			}
		}
	}

	// 将绘制边框的函数单独抽离出来
	const drawImageBorder = (x, y, w, h, border) => {
		ctx.save();
		const { width, style, color } = border;
		ctx.strokeStyle = color;
		ctx.lineWidth = width;
		ctx.beginPath();
		ctx.moveTo(x, y);
		ctx.lineTo(x + w, y);
		ctx.lineTo(x + w, y + h);
		ctx.lineTo(x, y + h);
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	};

	// 等待所有图片加载完成
	await Promise.all(imagePromises);
}

/**
 * @description 获取截图 base64 数据后，需要进行水印优化
 */
function optimizeWatermark(screenshotBase64) {}

/**
 * @description 辅助函数 - 判断图片是否被裁剪
 * @param {width: 304, height: 64, offsetLeft: 0, offsetTop: 0} crop 图片对象
 * @param {width: 304, height: 64 } info 图片信息对象
 * @returns {boolean}
 */
function isCrop(crop, info) {
	return !(crop.width === info.width && crop.height === info.height && crop.offsetLeft === 0 && crop.offsetTop === 0);
}

/**
 * @description 辅助函数 - 判断图片是否在打印区域内
 */
function isInPrintRange({ scrollWidth, scrollHeight, ch_width, rh_height, left, top, width, height }) {
	// 判断图片是否在打印范围内
	// 宽松的条件：四个角点有一个在范围内，则认为处于打印区域
	const topLeft = left >= scrollWidth && top >= scrollHeight && left <= scrollWidth + ch_width && top <= scrollHeight + rh_height;
	const topRight =
		left + width >= scrollWidth && top >= scrollHeight && left + width <= scrollWidth + ch_width && top <= scrollHeight + rh_height;
	const bottomLeft =
		left >= scrollWidth && top + height >= scrollHeight && left <= scrollWidth + ch_width && top + height <= scrollHeight + rh_height;
	const bottomRight =
		left + width >= scrollWidth &&
		top + height >= scrollHeight &&
		left + width <= scrollWidth + ch_width &&
		top + height <= scrollHeight + rh_height;
	return topLeft || topRight || bottomLeft || bottomRight;
}

/**
 * @description 切换视图
 */
function switchViewBtn($t) {
	let $viewList = $t.parent(),
		preType = $viewList.find("luckysheet-print-viewBtn-active").attr("type");
	if ($t.attr("type") == preType) {
		return;
	}

	let curType = $t.attr("type");
	if (curType != null) {
		viewChange(curType, preType);
	} else {
		return;
	}

	$t.parent().find(".luckysheet-print-viewBtn").removeClass("luckysheet-print-viewBtn-active");
	$t.addClass("luckysheet-print-viewBtn-active");
}

// 初始化打印
function printInitial() {
	let container = luckysheetConfigsetting.container;
	let _this = this;
	$("#" + container)
		.find(".luckysheet-print-viewBtn")
		.click(function () {
			switchViewBtn($(this));
		});
}

/**
 * @description 打开打印预览页面，进行参数配置后执行打印操作
 * @param {Array} imageList 打印图片列表 ，每一个图片对象，就表示单独一页，请再传入之前自行处理好页码关系
 */
function initWindowPrintPreview(imageList) {
	if (!imageList || !imageList.length) return;

	// 创建 iframe 容器
	const printIframe = document.createElement("iframe");
	printIframe.classList = "print-preview-iframe";
	document.querySelector("body").append(printIframe);

	// 获取 iframe 的 document 对象
	const iframeDocument = printIframe.contentDocument;
	if (iframeDocument == null) return;

	// 定义打印样式 @print
	initPrintStyle(iframeDocument);

	// 创建 print-box 容器,内部创建 print-page 实现页码分割
	const printBox = document.createElement("div");
	printBox.className = "print-box";
	printBox.style.cssText = `
		position: absolute;
		top: 0;
		left: 0;
		box-sizing: border-box;
		background: white;
		border: solid transparent 0px;
		z-index: 9999;
		padding: 1px;
	`;

	// 根据 imageList 创建 print-page
	createPrintPage(printBox, imageList);

	iframeDocument.body.append(printBox);

	/** 实现打印水印 */
	createPrintWatermark(iframeDocument);

	// 执行打印
	setTimeout(() => {
		printIframe.contentWindow.print();
		printIframe.remove();
	}, 100);
}

/**
 * @description 打印预览 - 打印样式,可以在这里设定一些打印相干参数 是否打印网格线|调整页面边距|打印缩放等
 */
function initPrintStyle(iframeDocument) {
	const style = document.createElement("style");
	style.media = "print";
	style.innerText = `@page { size: auto; }`;
	iframeDocument.head.append(style);
}

/**
 * @description 打印预览 - 根据传入的图片，创建 print-page
 */
function createPrintPage(printBox, imageList) {
	printBox.innerHTML = imageList
		.map(
			(src) => `
	<div style="
		width: 210mm;
		height: 297mm;
		border: solid transparent 0px;">
		<img 
			style="
				max-width:100%;
				border: solid transparent 0px;
				height:fit-content;" 
			src="${src}" 
			border="0" />
		</div>`
		)
		.join("");
}

/**
 * @description 打印预览 - 实现打印水印
 */
function createPrintWatermark(iframeDocument) {
	// 1. 获取内部的 print-box 元素
	const printBox = iframeDocument.querySelector(".print-box");
	const { clientWidth, clientHeight } = printBox;

	// 2. 创建 canvas
	const canvas = iframeDocument.createElement("canvas");
	canvas.width = clientWidth;
	canvas.height = clientHeight;
	canvas.style.cssText = `
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10000;
		width: ${clientWidth}px;
		height: ${clientHeight}px;
	`;
	iframeDocument.body.append(canvas);

	// 3. 绘制水印
	const ctx = canvas.getContext("2d");

	// 保存画布状态
	ctx.save();

	// 设置水印文本样式
	ctx.fillStyle = "rgba(0,0,0,0.04)";
	ctx.font = "bold 20px Arial";

	// 获取文本尺寸
	const text = "Luckysheet-crdt";
	const textWidth = ctx.measureText(text).width;
	const textHeight = 20; // 大致的文本高度

	// 计算对角线长度和旋转后的占用空间
	const diagonal = Math.sqrt(clientWidth * clientWidth + clientHeight * clientHeight);
	const watermarkSpacing = Math.max(textWidth, textHeight) * 1.5; // 水印间距

	// 旋转整个画布 -45度
	ctx.translate(clientWidth / 2, clientHeight / 2);
	ctx.rotate(-Math.PI / 4);

	// 在旋转后的坐标系中绘制平铺的水印
	for (let x = -diagonal; x < diagonal; x += watermarkSpacing) {
		for (let y = -diagonal; y < diagonal; y += watermarkSpacing * 0.5) {
			ctx.fillText(text, x, y);
		}
	}

	// 恢复画布状态
	ctx.restore();
}

/**
 * @description 用户打印指定页面,需要有 dialog 支持
 */
function openPrintPageDialog(callback) {
	// 如果存在，则先删除
	$("#luckysheet-modal-dialog-mask")?.hide();
	$("#luckysheet-print-page-dialog")?.remove();

	// 使用 modelHTML 创建模态框
	$("body").append(
		replaceHtml(modelHTML, {
			id: "luckysheet-print-page-dialog",
			addclass: "luckysheet-print-page-dialog",
			title: "打印指定页码",
			content: `<input type="text" placeholder="请输入页码,多个页码用逗号分割">`,
			botton:
				'<button class="btn btn-primary luckysheet-model-confirm-btn">' +
				"确认" +
				"</button>" +
				'<button class="btn btn-default luckysheet-model-close-btn">' +
				"取消" +
				"</button>",
			style: "z-index:100003",
		})
	);

	// 居中
	let $t = $("#luckysheet-print-page-dialog").find(".luckysheet-modal-dialog-content").css("min-width", 260).end(),
		myh = $t.outerHeight(),
		myw = $t.outerWidth();
	let winw = $(window).width(),
		winh = $(window).height();
	let scrollLeft = $(document).scrollLeft(),
		scrollTop = $(document).scrollTop();

	$("#luckysheet-print-page-dialog")
		.css({ left: (winw + scrollLeft - myw) / 2, top: (winh + scrollTop - myh) / 3 })
		.show();

	setTimeout(() => {
		// 自动获取焦点
		$("#luckysheet-print-page-dialog input").focus();
	}, 10);

	// 关闭模态框
	function closeDialog() {
		$("#luckysheet-modal-dialog-mask")?.hide();
		$("#luckysheet-print-page-dialog")?.remove();
	}

	// 确认按钮
	$("#luckysheet-print-page-dialog .luckysheet-modal-dialog-buttons .luckysheet-model-confirm-btn").click(function () {
		const page = $("#luckysheet-print-page-dialog input").val().trim();
		// 将二维数组转为一维数组
		const pageArray = page
			.split(",")
			.map((i) => i.split("，"))
			.reduce((pre, cur) => {
				return pre.concat(cur);
			}, [])
			.map(Number);
		if (callback && typeof callback === "function") callback(pageArray);

		// 关闭模态框
		closeDialog();
	});
}

/**
 * @description 用户自行选择打印范围 - 调用数据验证控制器的方法，实现唤起单元格选择器
 * 这里用到两个选区操作的 API
 *  1. getRangeAxis 获取选区文本 直接返回 A2:F4
 *  2. getTxtByRange 将 range 转成文本 需要传入 range = { row:[1,2],comlumn:[1,2] }
 */
function selectPrintArea(callback, defaultRange) {
	const _this = dataVerificationCtrl;

	// 这个文本默认为当前用户的选区
	const defaultRangeArray = getRangeAxis();

	// 打印只支持单个选区 - 默认最后一个选区
	const defaultRangeText = defaultRangeArray[defaultRangeArray.length - 1];
	let txt = defaultRangeText;

	// 如果用户传递了选区参数，则使用用户的参数选区
	if (defaultRange != null) {
		if (getObjType(defaultRange) == "string") {
			if (!formula.iscelldata(defaultRange)) {
				return tooltip.info("The range parameter is invalid.", "");
			}
			txt = defaultRange;
		} else if (getObjType(defaultRange) == "object" && defaultRange.row !== null && defaultRange.column !== null) {
			// 用户传入的是对象 range = { row:[1,2],comlumn:[1,2] }，需要转换为文本格式
			txt = getTxtByRange(defaultRange);
		} else return tooltip.info("The range parameter is invalid.", "");
	}

	_this.rangeDialog(null, txt);

	_this.selectRange = [];

	let range = _this.getRangeByTxt(txt);

	formula.rangetosheet = Store.currentSheetIndex;

	if (range[0].sheetIndex != Store.currentSheetIndex) {
		sheetmanage.changeSheetExec(range[0].sheetIndex);
	}

	if (range.length > 0) {
		for (let s = 0; s < range.length; s++) {
			let r1 = range[s].row[0],
				r2 = range[s].row[1];
			let c1 = range[s].column[0],
				c2 = range[s].column[1];

			let row = Store.visibledatarow[r2],
				row_pre = r1 - 1 == -1 ? 0 : Store.visibledatarow[r1 - 1];
			let col = Store.visibledatacolumn[c2],
				col_pre = c1 - 1 == -1 ? 0 : Store.visibledatacolumn[c1 - 1];

			_this.selectRange.push({
				left: col_pre,
				width: col - col_pre - 1,
				top: row_pre,
				height: row - row_pre - 1,
				left_move: col_pre,
				width_move: col - col_pre - 1,
				top_move: row_pre,
				height_move: row - row_pre - 1,
				row: [r1, r2],
				column: [c1, c2],
				row_focus: r1,
				column_focus: c1,
			});
		}
	}

	selectionCopyShow(_this.selectRange);

	// 确认按钮
	$(document)
		.off("click.dvRangeConfirm")
		.on("click.dvRangeConfirm", "#luckysheet-dataVerificationRange-dialog-confirm", function (e) {
			// 当前选定的选区为
			const range = $(this).parents("#luckysheet-dataVerificationRange-dialog").find("input").val();
			// 通过回调实现选区传递
			if (callback && typeof callback === "function") callback({ range });
			closeSelection();
		});

	// 关闭按钮
	$(document).off("click.dvRangeClose").on("click.dvRangeClose", "#luckysheet-dataVerificationRange-dialog-close", closeSelection);

	// 模态框关闭
	$(document).on("click", "#luckysheet-dataVerificationRange-dialog .luckysheet-modal-dialog-title-close", closeSelection);
}

/**
 * @description 工具函数 - 计算文本宽度
 */
function getTextWidth(ctx, text) {
	return ctx.measureText(text).width;
}

/**
 * @description 工具函数 - 计算文本高度
 */
function getTextHeight(ctx, text) {
	const metrics = ctx.measureText(text);
	return metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
}

/**
 * @description 工具函数 - 关闭选区，并清空选区数据
 */
function closeSelection() {
	$("#luckysheet-dataVerificationRange-dialog").hide();
	$("#luckysheet-modal-dialog-mask").hide();
	selectionCopyShow([]);
}

/**
 * @description 打开打印预览页面，该页面主要实现一些打印参数设定，例如： 是否打印网格线|调整页面边距|打印缩放等
 * 		设定完毕后，直接重新调用打印接口 initWindowPrintPreview，将最新的图片列表传入即可
 */
async function openPrintPreview(itemvalue, needToPreview = true) {
	// 目前支持的打印方式为
	const supportedPrintTypes = ["sheet", "areas", "pages"];
	if (!itemvalue || !supportedPrintTypes.includes(itemvalue)) return console.warn("打印预览参数错误");

	// 打印当前sheet
	if (itemvalue == "sheet") {
		handleSheetPrint({ needToPreview });
	}
	// 打印指定选区
	else if (itemvalue == "areas") {
		handleAreasPrint(needToPreview);
	}
	// 打印指定页码
	else if (itemvalue == "pages") {
		handlePagesPrint(needToPreview);
	}
}

/**
 * @description 创建预览试图
 */
function initPrintPreviewContainer(imageList, printType) {
	if (!imageList || !imageList.length) return;

	let $dialog = null;

	// 如果不存在 预览窗口，则创建
	if (!$(".luckysheet-print-preview-box").length) {
		// 实现简单的打印参数设定即可
		$dialog = $(`
	<div class="luckysheet-print-preview-box">
		<div class="luckysheet-print-preview-box-header"> <span>打印预览</span> <button>退出预览</button> </div>

		<div class="luckysheet-print-preview-container">
			<div class="luckysheet-print-preview-images">
			</div>
			<div class="luckysheet-print-preview-settings">
				<div class="luckysheet-print-preview-settings-header">
					<span>打印设置</span>
				</div>
				<div class="luckysheet-print-preview-settings-item">
					<label for="grid-line">网格线</label>
					<input type="checkbox" id="grid-line" name="grid-line" checked />
				</div>

				<div class="luckysheet-print-preview-settings-item">
					<label for="page-margin">页边距</label>
					<select disabled id="page-margin" name="page-margin">
						<option value="0" selected>0mm</option>
						<option value="5">5mm</option>
						<option value="10">10mm</option>
						<option value="15">15mm</option>
						<option value="20">20mm</option>
					</select>
				</div>

				<div class="luckysheet-print-preview-settings-item">
					<label for="page-scale">缩放</label>
					<input disabled type="number" id="page-scale" name="page-scale" step="0.1" min="0.1" max="5" value="1" />
				</div>

				<div class="luckysheet-print-preview-settings-confirm">
					<button>确认打印</button>
				</div>
			</div>
		</div>
		</div>`);

		$dialog.appendTo($("body"));
	} else $dialog = $(".luckysheet-print-preview-box");

	// 1. 获取图片 container 容器，将 imageList 转为 img 标签
	const $images = $dialog.find(".luckysheet-print-preview-images");

	$images.html(
		imageList
			.map(
				(src) => `<div class="luckysheet-print-preview-images-item" >
							<img src="${src}" border="0" class="print-box" />
						</div>`
			)
			.join("")
	);

	// 2. 动态设置图片的宽高，使其比例始终为 A4 纸张比例,高度固定为 100%
	const a4Width = 210;
	const a4Height = 297;

	const parentHeight = $(".luckysheet-print-preview-images").height();
	const parentWidth = (a4Width / a4Height) * parentHeight;

	$images.find("div").css({
		width: parentWidth,
		height: parentHeight,
	});

	// 关闭按钮
	$dialog.find(".luckysheet-print-preview-box-header button").click(function () {
		$dialog.remove();
	});

	// 网格线 checkbox
	$dialog
		.find("#grid-line")
		.off("change")
		.change(async function () {
			const isChecked = $(this).prop("checked");

			// 根据当前用户是否选定网格线，重新生成新的图片列表 printType
			if (printType == "sheet") {
				handleSheetPrint({ printGridLine: isChecked });
			} else if (printType == "areas") {
				// 如果打印选区丢失，则默认为当前选区
				const range = printParam.printSelection || Store.luckysheet_select_save[0];
				const imageList = [await getScreenshotBySelection({ range }, isChecked)];
				initPrintPreviewContainer(imageList, "areas");
			} else if (printType == "pages") {
				const pageArray = printParam.pageArray || [];
				const imageList = [];
				// 不能直接传入函数,应该循环处理
				// const imageList = pageArray.map(async (pageNum) => await getScreenshotByPageNum(pageNum));
				for (let i = 0; i < pageArray.length; i++) {
					const pageScreenshot = await getScreenshotByPageNum(pageArray[i], isChecked);
					if (pageScreenshot) imageList.push(pageScreenshot);
				}

				initPrintPreviewContainer(imageList, "pages");
			}
		});

	//  确认打印按钮
	$dialog
		.find(".luckysheet-print-preview-settings-confirm button")
		.off("click")
		.click(function () {
			initWindowPrintPreview(imageList);
		});
}

/**
 * @description 为了更好实现打印网格线，需要单独抽离三种方式实现
 */
async function handleSheetPrint(options = {}) {
	// 默认 是否需要打印网格线为 true
	const { printGridLine = true, needToPreview = true } = { ...options };

	const imageList = await getScreenshotBySheet(null, printGridLine);

	// 如果是API调用，用户不需要预览，则直接调用系统方法即可
	if (!needToPreview) return initWindowPrintPreview(imageList);

	initPrintPreviewContainer(imageList, "sheet");
}
async function handleAreasPrint(needToPreview) {
	// 打印选区只能返回一个截图，因此需要自己组装 array
	selectPrintArea(async ({ range }) => {
		printParam.printSelection = range;
		const imageList = [await getScreenshotBySelection({ range })];

		if (!needToPreview) return initWindowPrintPreview(imageList);

		initPrintPreviewContainer(imageList, "areas");
	});
}
async function handlePagesPrint(needToPreview) {
	// 1. 打开预览视图
	const $t = $(".luckysheet-print-viewBtn.luckysheet-print-viewPage");
	switchViewBtn($t);
	// 2. 打开弹窗,要求输入需要打印的页码,确认后调用 printPreview
	setTimeout(() => {
		openPrintPageDialog(async (pageArray) => {
			// 存储数据
			printParam.pageArray = pageArray;
			const imageList = [];
			// 不能直接传入函数,应该循环处理
			// const imageList = pageArray.map(async (pageNum) => await getScreenshotByPageNum(pageNum));
			for (let i = 0; i < pageArray.length; i++) {
				const pageScreenshot = await getScreenshotByPageNum(pageArray[i]);
				if (pageScreenshot) imageList.push(pageScreenshot);
			}

			if (!needToPreview) return initWindowPrintPreview(imageList);

			initPrintPreviewContainer(imageList, "pages");
		});
	}, 100);
}

export {
	// 初始化打印
	printInitial,
	// 创建打印线和页码
	printLineAndNumberCreate,
	// 打印预览
	openPrintPreview,
};
